import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import { NotificationsList } from '../organism/NotificationsList';

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownContent = styled.div<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  z-index: 1000;
  min-width: 400px;
  max-height: 600px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme }) => theme.border.radius.lg};
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background2};
`;

const Overlay = styled.div<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: transparent;
`;

type NotificationsDropdownProps = {
  children: React.ReactNode;
};

export const NotificationsDropdown = ({ children }: NotificationsDropdownProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsVisible((prev) => !prev);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  // Cerrar al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        handleClose();
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <>
      <Overlay $isVisible={isVisible} onClick={handleClose} />
      <DropdownContainer ref={containerRef}>
        <div onClick={handleToggle} style={{ cursor: 'pointer' }}>
          {children}
        </div>
        <DropdownContent ref={dropdownRef} $isVisible={isVisible}>
          <NotificationsList onClose={handleClose} onMarkAllAsReadOnClose={handleClose} />
        </DropdownContent>
      </DropdownContainer>
    </>
  );
};

